<ng-content></ng-content>
<div class="text-right counter-container">
  <span class="caption text-darkgray counter">
    {{ value?.length || 0
    }}<ng-container *ngIf="withLimit; else prefix"
      >/{{ withLimit }} {{ 'common.validation.character_limit' | translate }}</ng-container
    >
  </span>
</div>

<ng-template #prefix> {{ 'common.validation.characters' | translate }}</ng-template>
